export const formatNumber = (value: number) =>
  Intl.NumberFormat('en-CA').format(value);
